import React from "react";
import Link from "next/link";
import { Dancing_Script } from "next/font/google";
import { useTranslation } from "@/contexts/TranslationContext";

const ds = Dancing_Script({
  weight: ["400", "500", "600", "700"], // amire szükség van
  subsets: ["latin"],
});

export default function FeaturedEvent() {
  const { t } = useTranslation();
  
  return (
    <div className="bg-black text-white w-full min-h-[50vh] flex flex-col md:flex-row items-center py-16">
      {/* Bal oldal: Szöveg és gomb */}
      <div className="w-full md:w-1/2 flex flex-col items-center justify-center text-center px-8 mb-8 md:mb-0">
        <h2 className={`${ds.className} text-3xl md:text-4xl font-handwriting text-[#fe64db] mb-6`}>
          {t("featured_event.title")}
        </h2>
        <p className="text-lg md:text-xl mb-6">
          {t("featured_event.description")}
        </p>
        <Link
          href="https://www.kulturklub.eu/kulturklub-ajandekkartya"
          className="bg-[#fe64db] text-white px-6 py-3 rounded hover:opacity-90 transition-opacity duration-300 animate-pulse"
        >
          {t("featured_event.cta")}
        </Link>
      </div>

      {/* Jobb oldal: Videó */}
      <div className="w-full md:w-1/2 h-full flex items-center justify-center px-4">
        <Link
          href="https://www.kulturklub.eu/kulturklub-ajandekkartya"
          className="block w-full max-w-[500px] overflow-hidden rounded-lg"
        >
          <div className="relative w-full h-0 pb-[100%]">
            <img
              className="absolute top-0 left-0 w-full h-full object-cover rounded-lg transition-transform duration-300 hover:scale-110"
              src="https://www.kulturklub.eu/uploads/kulturklub_ajandekkartya_2026_ac1fcc4d59_4656b5d77b.webp" // <-- Itt add meg a kép elérési útját
              alt="KultúrKlub ajándékkártya"
            />
          </div>
        </Link>
      </div>
    </div>
  );
}
